/* Core & libraries */
import * as React from "react";
import { useTheme } from "react-jss";
import Toggle from 'react-toggle'
import "react-toggle/style.css"

/* Helpers, constants, custom methods, internal libraries */
import { useSpinnersContext } from "../../contexts/spinnersContext";
/* Components */
import Spinner from "../spinners/buttonSpinner";
/* Styles */
import styles from "./styles.js"

const UCToggle = props => {
  const { defaultChecked, icons, onChange, className, label, disabled, name, onClick, spinner, spinnerClassName, isChecked, ariaLabel } = props;

  const theme = useTheme();
  const classes = styles({ theme });
  const spinners = useSpinnersContext();

  //determine if the component is controlled or not in order to manually change the toggle value and avoid breaking it where it is used as uncontrolled.
  const isControlled = typeof isChecked !== 'undefined';

  const handleClick = (e) => {
    e.currentTarget.blur();
    onClick?.(e);
  };

  return (
    <div className={classes.toggle}>
    {
      spinners[spinner?.name] ? (
        <Spinner size={spinner['size']} color={theme.spinners["general"]} customClass={spinnerClassName}/>
      ) :
      <div className={classes.toggle}>
        <Toggle
          {...(isControlled ? { checked: isChecked } : { defaultChecked })} 
          defaultChecked={defaultChecked}
          icons={icons}
          onChange={onChange} 
          className={className}
          disabled={disabled}
          name={name}
          onClick={handleClick}
          aria-label={ariaLabel}
        />
        <span>{label}</span>
      </div>
    }
    </div>
  )
}

export default UCToggle;
